// extracted by mini-css-extract-plugin
module.exports = {"grid":"GameList_grid__17XYg"};